import {
	Box,
	makeStyles, TextField,
	Typography, MenuItem
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { mdiThermometer, mdiTools, mdiRobber, mdiSpeedometer, mdiLockOpen, mdiTowTruck, mdiPower } from '@mdi/js';
import Icon from '@mdi/react';
import { useValues } from 'kea';

import profilelogic from 'src/store/profile';

import checkRole from '../../../utils/checkRole';
import AddVehicleDialog from './AddVehicleDialog';
import AssignGroupDialog from './AssignGroupDialog';
import EditAlertDialog from './EditAlertDialog';
import RemoveAlertDialog from './RemoveAlertDialog';

//TODO clean styles
const useStyles = makeStyles((theme) => ({
	root: {},
	importButton: {
		marginRight: theme.spacing(1)
	},
	exportButton: {
		marginRight: theme.spacing(1)
	},
	formControl: {
		minWidth: 300
	}
}));

const Toolbar = ({ selectedAlert, select_filter, rows }) => {
	const classes = useStyles();
	let set_select_filter = select_filter;
	const { profile } = useValues(profilelogic);
	const [alert, setAlert] = React.useState('');

	const reset = () => {
		setAlert('')
		set_select_filter(null);
	}

	const handle_select = (e) => {
		setAlert(e.target.value)
		set_select_filter(e.target.value);
	}

	return (
		<div>
			<Box
				display="flex"
				justifyContent="flex-end"
			>
			</Box>
			<Box mt={3}>

				<Box >
					{
						rows.length === 0 ?
							<Typography>
								Please Create an Alert First
							</Typography>
							:
							<div style={{ display: 'flex', flexGrow: 1 }}>
								<TextField
									id="outlined-select-alert"
									select
									error={alert === "" ? true : false}
									label="Select an Alert"
									value={alert}
									onChange={handle_select}
									helperText={alert === "" ? "Please select an Alert" : null}
									variant="outlined"
									minWidth="400px"
									className={classes.formControl}
								>
									{
										rows.map((row, index) => {
											return (
												<MenuItem key={index} value={index}>
													<div style={{
														display: 'flex',
														flexGrow: '1'
													}}>
														<div style={{ marginRight: '5px' }}>
															{row.condition.monitor === 'speed' && <Icon path={mdiSpeedometer} size={1}></Icon>}
															{row.condition.monitor === 'stolen' && <Icon path={mdiRobber} size={1}></Icon>}
															{row.condition.monitor === 'service' && <Icon path={mdiTools} size={1}></Icon>}
															{row.condition.monitor === 'temperature' && <Icon path={mdiThermometer} size={1}></Icon>}
															{row.condition.monitor === 'tamper' && <Icon path={mdiLockOpen} size={1}></Icon>}
															{row.condition.monitor === 'towing' && <Icon path={mdiTowTruck} size={1}></Icon>}
															{row.condition.monitor === 'offline' && <Icon path={mdiPower} size={1}></Icon>}
														</div>
														{row.name}
													</div>
												</MenuItem>
											)
										})
									}
								</TextField>
								{
									alert !== '' && selectedAlert ?
										<div style={{ alignItems: 'center', display: 'flex', flexGrow: 1, paddingLeft: '22px', paddingTop: '5px' }}>
											{checkRole(profile, ['AlertEdit']) &&
												<>
													<AddVehicleDialog alertIndex={alert} selectedAlert={selectedAlert} />
													<div style={{ paddingLeft: '12px' }} />
													<EditAlertDialog alert={rows[alert]} />
												</>
											}
											{checkRole(profile, ['Admin']) && <>
												<div style={{ paddingLeft: '12px' }} />
												<AssignGroupDialog selectedAlert={selectedAlert} />
											</>}
											{checkRole(profile, ['AlertEdit']) && <>
												<div style={{ paddingLeft: '12px' }} />
												<RemoveAlertDialog reset={reset} alert={rows[alert]} />
											</>}
										</div>
										:
										null
								}
							</div>
					}
				</Box>

			</Box>
		</div>
	);
};

Toolbar.propTypes = {
	className: PropTypes.string,
};

export default Toolbar;
